import { WebchatAttachment } from "@/components/molecules/interactionWorkspace";
import { InteractionDto } from "./interactions";
import { SendType } from "@/common/stores/nonpersistingStores/currentInteraction";

export interface Message {
	id: string;
	receivedDateTime: string;
	attachments: AttachmentData[];
	subject: string;
	body: EmailBody;
	sender: Recipient;
	toRecipients: Recipient[];
	ccRecipients: Recipient[];
	bccRecipients: Recipient[];
	isDraft: boolean;
	actionType: EmailAction;
	hasAiContent?: boolean;
}

export enum EmailAction {
	Reply = 0,
	ReplyAll = 1,
	Forward = 2,
}

export interface Recipient {
	name: string;
	address: string;
}

export interface EmailBody {
	content: string;
}

export interface AttachmentData {
	id: string;
	contentId: string;
	name: string;
	size: number;
	contentType: string;
	lastModifiedDateTime: string;
	isInline: boolean;
	contentBytes: string;
}

export interface SendMessageData {
	subject?: string;
	body: string;
	to: Recipient[];
	cc: Recipient[];
	bcc: Recipient[];
	attachments: SendAttachmentData[];
	sendType?: SendType;
	hasAiContent?: boolean;
}

export interface SendAttachmentData {
	id?: string;
	name: string;
	contentBytes: string;
	contentType: string;
	contentId?: string;
	isInline: boolean;
	toRemove: boolean;
}

export interface EmailTrustedEndpoint {
	id: string;
	identifier: string;
	name: string;
	email: string;
	queueName: string;
	queueId: string;
	flowId: string;
	assignedMediaName: string;
}

export interface EmailOutboundRequest {
	to: Recipient[];
	endpointId: string;
	queueId: string;
}

export interface ReopenEmailResult {
	interaction: InteractionDto;

	status: ReopenEmailStatus;
}

export enum ReopenEmailStatus {
	OutboundConversationHasNoEmails = -4,
	OriginalNotHandledByCurrentAgent = -3,
	AlreadyOpenByOther = -2,
	UnexpectedError = -1,
	AlreadyOpen = 0,
	Reopened = 1,
}

export interface WebchatReplyMessageModel {
	message: string;
	attachments: WebchatAttachment[];
}

export interface FileUploadSasUrlResponse {
	id: string;
	url: string;
}

export interface FileUploadSasUrlRequest {
	id: string;
	name: string;
}

export interface ConversationMessages {
	messages: Message[];
	isSubjectChangedByLastMessage: boolean;
	draftParentMessageId?: string;
	emailAction?: EmailAction;
}